"use strict";

module.exports = function (ngModule) {
  ngModule.constant("formlyErrorAndWarningsUrlPrefix", "https://github.com/formly-js/angular-formly/blob/" + VERSION + "/other/ERRORS_AND_WARNINGS.md#");
};


/*****************
 ** WEBPACK FOOTER
 ** ./providers/formlyErrorAndWarningsUrlPrefix.js
 ** module id = 13
 ** module chunks = 0
 **/